import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H5, P } from "../../../../AbstractElements";
import { Href, LatestUpdatesTitle } from "../../../../Constants/Constants";
import { LatestUpdatesData } from "../../../../Data/Miscellaneous/FAQ";

const LatestUpdates = () => {
  return (
    <Col lg="12">
      <Card>
        <CardHeader className="faq-header pb-0">
          <H5 className="d-inline-block">{LatestUpdatesTitle}</H5>
          <span className="pull-right d-inline-block">{"See All"}</span>
        </CardHeader>
        <CardBody className="faq-body">
          {LatestUpdatesData.map((data) => (
            <div className="d-flex updates-faq-main" key={data.id}>
              <div className="updates-faq">{data.icon}</div>
              <div className="flex-grow-1 updates-bottom-time">
                <P>{data.name} <a href={Href}>{data.anchor}</a> {data.title}</P>
                <P>{data.time}</P>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default LatestUpdates;
